import { OrganisationUnit, TenantHierarchy } from '@app/models';

export function findOuById(organisationUnit: OrganisationUnit, organisationUnitId: string): OrganisationUnit {
  if (organisationUnit.id === organisationUnitId) {
    return organisationUnit;
  }
  for (const child of organisationUnit.children) {
    const result = findOuById(child, organisationUnitId);
    if (result) {
      return result;
    }
  }
}

export function getParents(tenantHierarchy: TenantHierarchy, organisationUnit: OrganisationUnit): OrganisationUnit[] {
  if (organisationUnit.parentId) {
    const parentOu = findOuById(tenantHierarchy.organisationUnit, organisationUnit.parentId);
    let result = [parentOu];
    result = [...result, ...getParents(tenantHierarchy, parentOu)];
    return result;
  }
  return [];
}

export function getAllChildProducts(organisationUnit: OrganisationUnit): string[] {
  let result = [];
  if (organisationUnit.products.length > 0) {
    result = [...result, ...organisationUnit.products];
  }
  for (const child of organisationUnit.children) {
    const childProducts = getAllChildProducts(child);
    if (childProducts.length > 0) {
      result = [...result, ...childProducts];
    }
  }
  return result;
}

export function getAllChildMerchants(organisationUnit: OrganisationUnit): string[] {
  let result = [];
  if (organisationUnit.merchants.length > 0) {
    result = [...result, ...organisationUnit.merchants];
  }
  for (const child of organisationUnit.children) {
    const childMerchants = getAllChildMerchants(child);
    if (childMerchants.length > 0) {
      result = [...result, ...childMerchants];
    }
  }
  return result;
}
